import React, { useState } from "react";
import Modal from "react-modal";
import { isIOS, isChrome, isSafari } from "react-device-detect";
import BG from "../../assets/img/services/bgservice.png";
import P2P from "../../assets/img/services/P2P.png";
import ELWI from "../../assets/img/services/ELWI.png";
import SCI from "../../assets/img/services/SCI.png";
import FNS from "../../assets/img/services/FNS.png";
import FSM from "../../assets/img/services/FSM.png";
import MS from "../../assets/img/services/MS.png";
import PeerToPeer from "./PeerToPeer";
import FullScales from "./fullScale";
// import Web3 from "./Web3";
// import SmartContract from "./smartContract";
// import FullScales from "./fullScale";
// import Marketplace from "./Marketplace";

import BGAllTemplates from "../../assets/img/services/dekstop.png";
import Footer from "../../components/FooterService";
import Web3 from "./Web3";
import SmartContracts from "./smartContract";
import MarketPlace from "./Marketplace";
import FullNFT from "./fullNFT";

Modal.setAppElement("#root");
function Service() {
  const [open, setOpen] = useState(false);
  const [servicesValue, setServices] = useState(0);
  const isSmallerDevice = isIOS && (isChrome || isSafari);
  const [isOpen, setIsOpen] = useState(false);
  function toggleModal(value) {
    setOpen(!open);
    setServices(value);
    setIsOpen(!isOpen);
  }
  return (
    <div
      className="flex flex-col lg:flex-row sm:flex-cols-2 w-full h-screen bg-gradient-to-b from-[#2B2E82] to-[#0A0918]  bg-no-repeat bg-cover bg-fixed bg-center sm:p-0
      items-center justify-center"
      style={{ backgroundImage: `url(${BGAllTemplates})` }}
    >
      {/* Peer to Peer Modal */}
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModal}
        contentLabel="My dialog"
      >
        {servicesValue === 1 && <PeerToPeer />}
        {servicesValue === 2 && <Web3 />}
        {servicesValue === 3 && <SmartContracts />}
        {servicesValue === 5 && <FullScales />}
        {servicesValue === 4 && <MarketPlace />}
        {servicesValue === 6 && <FullNFT />}

        <Footer
          setOpen={setOpen}
          open={open}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isSmallerDevice={isSmallerDevice}
        />
        {/* <button onClick={toggleModal} type="button">
          Close modal
        </button> */}
      </Modal>
      {!open && (
        <div
          className="flex flex-col lg:flex-row sm:flex-cols-2 w-full h-screen justify-start bg-gradient-to-b from-[#3c66cb] to-[#4a46c8]  bg-no-repeat bg-cover bg-fixed bg-center sm:p-0 "
          style={{ backgroundImage: `url(${BG})` }}
        >
          <div className="lg:w-[40%] mt-[5rem] lg:flex lg:mt-[16%]">
            <div className="w-full pl-[14rem] sm:p-[2.8rem]">
              <div className=" flex text-left text-white lg:text-[24px] mb-2 text-[18px] break-words font-bold">
                EXPLORE OUR SERVICES
              </div>
              <div className="flex font-normal text-left text-white lg:text-[18px] text-[14px] text break-words lg:w-[100%]">
                At Nverse, we develop a wide array of tools and solutions that
                can be customized to fit your unique business needs.
              </div>
            </div>
          </div>
          <div className=" lg:w-[60%] flex items-center justify-center gap-x-[3.5rem] gap-y-[10em] sm:p-0 sm:-mt-[12rem]">
            <div className="grid sm:grid-cols-2 sm:grid-row-1 sm:scale-50 lg:grid-cols-3 gap-x-6 gap-y-6 sm:gap-y-4 sm:gap-x-[3rem] sm:ml-[-4rem] lg:scale-[0.7] xl:scale-100">
              <div
                className="rounded-lg h-60 w-60"
                style={{ background: "rgba(60, 102, 203, 1)" }}
              >
                <button type="button" onClick={() => toggleModal(1)}>
                  <div className=" m-10 mt-[1.4rem]">
                    <img src={P2P} alt="" />
                  </div>

                  <div
                    className=" block  -m-[1.5rem] sm:-m-[1.5rem] break-words lg:w-[70%] !-mt-[1.7rem] !m-auto
            text-center text-white"
                  >
                    PEER TO PEER COMPUTING
                  </div>
                </button>
              </div>
              <div
                className=" rounded-lg h-60 w-60"
                style={{ background: "rgba(60, 102, 203, 1)" }}
              >
                <button type="button" onClick={() => toggleModal(2)}>
                  <div className="m-5 ml-14 w-[55%]">
                    <img src={ELWI} alt="" />
                  </div>

                  <div className=" block -m-[1rem] sm:-m-[0.25rem] text-center text-white">
                    ENTERPRISE LEVEL WEB 3 IMPLEMENTATION
                  </div>
                </button>
              </div>
              <div
                className="rounded-lg h-60 w-60"
                style={{ background: "rgba(60, 102, 203, 1)" }}
              >
                <button type="button" onClick={() => toggleModal(3)}>
                  <div className=" lg:m-5 ml-14 ">
                    <img src={SCI} alt="" className="m-auto" />
                  </div>

                  <div
                    className="block lg:-m-[1.5rem] sm:m-[1rem]
            text-center text-white"
                  >
                    SMART CONTRACT IMPLEMENTATION
                  </div>
                </button>
              </div>
              <div
                className="rounded-lg h-60 w-60 "
                style={{ background: "rgba(60, 102, 203, 1)" }}
              >
                <button type="button" onClick={() => toggleModal(5)}>
                  <div className="  m-8 mt-4">
                    <img src={FSM} alt="" />
                  </div>
                  <div className="block -m-[1.5rem] sm:-m-[1.5rem] break-words lg:w-[70%] !-mt-[0.9rem] !m-auto">
                    FULL-SCALE MARKETPLACE
                  </div>
                </button>
              </div>
              <div
                className="rounded-lg h-60 w-60 mr-[13rem]"
                style={{ background: "rgba(60, 102, 203, 1)" }}
              >
                <button
                  type="button"
                  className="lg:mt-[-0.5rem]"
                  onClick={() => toggleModal(4)}
                >
                  <div className=" m-4  lg:ml-[2rem] ">
                    <img src={MS} alt="" />
                  </div>
                  <div className="block -m-[1.5rem] sm:-m-[1.5rem] break-words lg:w-[70%] !-mt-[0.9rem]  !m-auto">
                    METAVERSE SERVICE
                  </div>
                </button>
              </div>
              <div
                className="rounded-lg h-60 w-60"
                style={{ background: "rgba(60, 102, 203, 1)" }}
              >
                <button
                  type="button"
                  className="lg:mt-[1.5rem]"
                  onClick={() => toggleModal(6)}
                >
                  <div className="  m-6 ml-12 mt-[1rem] ">
                    <img src={FNS} alt="" />
                  </div>
                  <div className="block -m-[1.5rem] sm:-m-[1.5rem] break-words lg:w-[70%] !-mt-[0.9rem] !m-auto">
                    FULL NFT SUITE
                  </div>
                </button>
              </div>
            </div>
          </div>

          {/* bg text */}
          <h2 className="fixed -bottom-[12%] font-bold text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] h2Mobile md:block hidden">
            SERVICES
          </h2>
        </div>
      )}
    </div>
  );
}

export default Service;
